// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{body{height:100%;overflow:visible!important;-webkit-print-color-adjust:exact;-moz-print-color-adjust:exact;-ms-print-color-adjust:exact;print-color-adjust:exact}button{display:none}table tr td:last-child{padding-right:10px!important}.print_btn{display:none}}", ""]);
// Exports
module.exports = exports;
